import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import IconTool from '../../../../IconTool';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var StoryNavPanelContainer = function StoryNavPanelContainer(_ref) {
  var className = _ref.className,
      activeSection = _ref.activeSection,
      setJumpSection = _ref.setJumpSection,
      sidePanelRef = _ref.sidePanelRef,
      contentSize = _ref.contentSize,
      theme = _ref.theme,
      navigationIcons = _ref.navigationIcons;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      isOverflown = _useState2[0],
      setIsOverflown = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      lastSidePanelHeight = _useState4[0],
      setLastSidePanelHeight = _useState4[1];

  var navPanelCasesRef = useRef();
  var navPanel = useRef();

  var classes = function classes(name) {
    return classnames(name, {}, 'is-' + theme + '-theme', className);
  };

  useEffect(function () {
    var _navPanel$current;

    navPanel !== null && navPanel !== void 0 && (_navPanel$current = navPanel.current) !== null && _navPanel$current !== void 0 && _navPanel$current.offsetHeight ? sidePanelRef.current.offsetHeight !== lastSidePanelHeight ? navPanel.current.offsetHeight > sidePanelRef.current.offsetHeight ? (setIsOverflown(true), setLastSidePanelHeight(sidePanelRef.current.offsetHeight)) : (setIsOverflown(false), setLastSidePanelHeight(sidePanelRef.current.offsetHeight)) : null : null;
  }, [sidePanelRef, contentSize]);
  var sidePanelNodes = Array.from(sidePanelRef.current.childNodes);
  var navIconsArray = [];
  sidePanelNodes.forEach(function (node, index) {
    navIconsArray.push( /*#__PURE__*/_jsx(IconTool, {
      className: activeSection === index ? classnames(classes('ptr-StoryNavPanelIcon'), {}, 'is-active') : classes('ptr-StoryNavPanelIcon'),
      icon: index === 0 ? navigationIcons !== null && navigationIcons !== void 0 && navigationIcons.home ? navigationIcons.home : 'ri-home' : index === sidePanelNodes.length - 1 ? navigationIcons !== null && navigationIcons !== void 0 && navigationIcons.footer ? navigationIcons.footer : 'ri-square' : navigationIcons !== null && navigationIcons !== void 0 && navigationIcons["case"] ? navigationIcons["case"] : 'ri-dot',
      tooltip: {
        text: node.childNodes[0].innerText,
        position: 'right'
      },
      onClick: function onClick(e) {
        return scrollToSection(e, 'section');
      }
    }, index));
  });

  var scrollToSection = function scrollToSection(e, type) {
    var navPanelCasesNodes = Array.from(navPanelCasesRef.current.childNodes);

    switch (type) {
      case 'section':
        return navPanelCasesNodes.forEach(function (node, index) {
          var _sidePanelRef$current;

          node === e.currentTarget && activeSection !== index ? (sidePanelRef !== null && sidePanelRef !== void 0 && (_sidePanelRef$current = sidePanelRef.current) !== null && _sidePanelRef$current !== void 0 && _sidePanelRef$current.scrollTo({
            top: sidePanelNodes[index].offsetTop
          }), setJumpSection(index)) : null;
        });

      case 'up':
        return sidePanelNodes.forEach(function (node, index) {
          var _sidePanelRef$current2;

          node === sidePanelNodes[activeSection] && activeSection !== 0 ? sidePanelRef === null || sidePanelRef === void 0 ? void 0 : (_sidePanelRef$current2 = sidePanelRef.current) === null || _sidePanelRef$current2 === void 0 ? void 0 : _sidePanelRef$current2.scrollTo({
            top: sidePanelNodes[index - 1].offsetTop
          }) : null;
        });

      case 'down':
        return sidePanelNodes.forEach(function (node, index) {
          var _sidePanelRef$current3;

          node === sidePanelNodes[activeSection] && activeSection !== sidePanelNodes.length - 1 ? sidePanelRef === null || sidePanelRef === void 0 ? void 0 : (_sidePanelRef$current3 = sidePanelRef.current) === null || _sidePanelRef$current3 === void 0 ? void 0 : _sidePanelRef$current3.scrollTo({
            top: sidePanelNodes[index + 1].offsetTop
          }) : null;
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: classes('ptr-StoryNavPanelContainer'),
    ref: navPanel,
    children: [/*#__PURE__*/_jsx(IconTool, {
      className: classes('ptr-StoryNavPanelIcon'),
      icon: 'ri-chevron-up',
      onClick: function onClick(e) {
        return scrollToSection(e, 'up');
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "ptr-StoryNavPanelCases",
      ref: navPanelCasesRef,
      style: isOverflown ? {
        height: '0rem',
        overflow: 'hidden'
      } : {
        height: 'fit-content',
        overflow: 'visible'
      },
      children: navIconsArray
    }), /*#__PURE__*/_jsx(IconTool, {
      className: classes('ptr-StoryNavPanelIcon'),
      icon: 'ri-chevron-down',
      onClick: function onClick(e) {
        return scrollToSection(e, 'down');
      }
    })]
  });
};

StoryNavPanelContainer.propTypes = {
  className: PropTypes.string,
  activeSection: PropTypes.number,
  setJumpSection: PropTypes.func,
  sidePanelRef: PropTypes.object,
  isOverflown: PropTypes.func,
  contentSize: PropTypes.number,
  theme: PropTypes.string,
  navigationIcons: PropTypes.object
};
export default StoryNavPanelContainer;